var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"navMenu"}},[(!this.data.connexion)?_c('router-link',{attrs:{"to":"/tests"}},[_vm._v("Tests")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }